/*
 * Public SEO route aliases rendered by the landing page.
 *
 * Protected application routes such as /dashboard, /projects, /schools,
 * /history, /dispatches, and /verification are intentionally not listed here.
 * Authentication and utility routes are also excluded from SEO routing because
 * they are not public informational pages.
 */
export const PUBLIC_INFORMATIONAL_PATHS = [
  '/about',
  '/contact',
  '/programs',
  '/nutripathshala',
  '/meal-distribution',
  '/awareness-program',
  '/arogya-club',
] as const;
